import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Autocomplete, Button, Divider, Grid, MenuItem, Select, TextField, Typography, Snackbar, Alert } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { Props } from "./ModalDivice.type";
import { branchOfficeService } from "@/service/services/BranchOffice.service";
import { IntegrationDiviceService } from "@/service/services/IntegrationDiviceService";
import ___PHRASE from "@/service/translate/translateService";

export const ModalDivice: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, divice, getDivicesByCompany, company, clearState } = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [branchOffices, setBranchOffices] = useState<any>([])

    const [data, setData] = useState({
        serie: divice ? divice.serie : '',
        nameBD: divice ? divice.nameBD : '',
        userBD: divice ? divice.userBD : '',
        password: divice ? divice.password : '',
        model: divice ? divice.model : '',
        idbranch_office: divice ? divice.idbranch_office : '',
        area: divice ? divice.area : ''
    });

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
     })

    useEffect(()=> {
        getBranchOffice();
    },[]);

    const getBranchOffice = async () => {
        const resp = await branchOfficeService.getBranchOfficesByCompany(company.id);
        setBranchOffices(resp.data);
    }

    const validateForm = (values) => {
        let errors: any = {};
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {
        if(values.serie == '' || values.model == '' || values.userBD == '' || values.nameBD == '' || values.password == ''){
            return (
                setSnackBarConfig(prev => ({
                    ...prev, open: true,
                    severity: 'warning',
                    message: ___PHRASE("debeLlenarTodosLosCamposParaLaIntegracionDelControlAsistencia")
                }))
            );
        }
            
        setLoading(true);

        await IntegrationDiviceService.editDivice(values, divice.id).then((data) => {

            if(data.data.status == false){
                return (
                    setSnackBarConfig(prev => ({
                        ...prev, open: true,
                        severity: 'warning',
                        message: `${data.data.message || ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}`
                    }))
                );
            }

            closeModal && closeModal();
            getDivicesByCompany && getDivicesByCompany();
            clearState && clearState();
        });
        setLoading(false);
    }

    return(
        <>
        {loading && <Loading/>}
        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={___PHRASE("editarDispositivo")}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("sucursal")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Select
                                                id="idbranch_office"
                                                variant="standard"
                                                value={values.idbranch_office}
                                                onChange={(event) => { 
                                                setFieldValue("idbranch_office", event.target.value);
                                                }}
                                                error={ errors.idbranch_office && touched.idbranch_office ? true : false }
                                                fullWidth
                                            >
                                                {
                                                branchOffices.map((bracnh, i) => {
                                                    return <MenuItem key={i} value={bracnh.id}>{bracnh.address}</MenuItem>;
                                                })
                                                }
                                            </Select>
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("areaDelDispositivo")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="area"
                                                variant="standard"
                                                type="text" 
                                                name="area"
                                                fullWidth
                                                value={values.area}
                                                onChange={handleChange}
                                                label={___PHRASE("areaDelDispositivo")}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("usuarioDeBaseDeDatos")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="userBD"
                                                variant="standard"
                                                type="text" 
                                                name="userBD"
                                                fullWidth
                                                value={values.userBD}
                                                onChange={handleChange}
                                                label={___PHRASE("usuarioDeBaseDeDatos")}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("contrasena")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="password"
                                                variant="standard"
                                                type="text" 
                                                name="password"
                                                fullWidth
                                                value={values.password}
                                                onChange={handleChange}
                                                label={___PHRASE("contrasena")}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("nombreDeLaBaseDeDatos")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="nameBD"
                                                variant="standard"
                                                type="text" 
                                                name="nameBD"
                                                fullWidth
                                                value={values.nameBD}
                                                onChange={handleChange}
                                                label={___PHRASE("nombreDeLaBaseDeDatos")}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("serieDelDispositivo")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="serie"
                                                variant="standard"
                                                type="text" 
                                                name="serie"
                                                fullWidth
                                                value={values.serie}
                                                onChange={handleChange}
                                                label={___PHRASE("serieDelDispositivo")}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12} alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                            <Typography variant="body1"><b>{___PHRASE("modeloDelDispositivo")}:</b> </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <TextField
                                                id="model"
                                                variant="standard"
                                                type="text" 
                                                name="model"
                                                fullWidth
                                                value={values.model}
                                                onChange={handleChange}
                                                label={___PHRASE("modeloDelDispositivo")}
                                            />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={___PHRASE("actualizar")}
                                    cancelText={___PHRASE("cancelar")}
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}